var _ = require('lodash'),
    METRIC_TYPES = {
    1: 'timeSpentOnPage',
    2: 'idlePeriodId',
    3: 'timeSpentThisActive',
    4: 'timeSpentThisIdle',
    5: 'totalTimeSpentActive',
    6: 'totalTimeSpentIdle',
    7: 'totalTimeRemaining',
    8: 'ticketQuantity',
    9: 'searchRank'
},

/**
 * See https://docs.google.com/spreadsheets/d/1ARHpb4k49ZR_3aFRKku_9nLY-tjzR_g0XLeLYeqLRHI/edit?usp=sharing
 * for available dimensions. If adding a dimension, please update that spreadsheet!
 */
DIMENSION_TYPES = {
    1: 'pageScrollPosition',
    2: 'inFocusField',
    3: 'nameOfButton',
    4: 'locationOnPage',
    5: 'isOnDesignTab',
    6: 'howEntered',
    7: 'fieldChanged',
    8: 'isRepeating',
    9: 'ticketType',
    10: 'visibility',
    11: 'errorCode',
    12: 'eventId',
    13: 'temporaryObjectId',
    14: 'userId',
    15: 'managePage',
    16: 'isFirstCreateView',
    17: 'isFirstCreateSave',
    18: 'isFirstPublish',
    19: 'isFirstOrder',
    20: 'sessionId',
    21: 'experimentId',
    23: 'urlParams',
    24: 'guestId',
    28: 'eventOwnerUserId',
    38: 'experimentId3',
    50: 'correlationId',
    51: 'activeScopeUserId',
    52: 'searchId',
    54: 'eventSource',
    55: 'checkoutStep',
    56: 'organizationVertical'
};

function _invertMapping(values, type) {
    return _.transform(values, function (memo, value, index) {
        memo[value] = '' + type + index; // eslint-disable-line no-param-reassign
    });
}

module.exports = {
    METRICS: _invertMapping(METRIC_TYPES, 'metric'),
    DIMENSIONS: _invertMapping(DIMENSION_TYPES, 'dimension'),
    TRACK_EVENT_REQUIRED_PROPS: ['category', 'action'],
    TRACK_USER_TIMING_REQUIRED_PROPS: ['category', 'var', 'value'],
    EB_GA_PROPERTY_FOR_GA: ['page', 'referrer', 'useBeacon', 'location', 'hostname', 'title']
};